import angular from 'angular';
import accountSettingsModule from '../accountSettingsModule';

function accountSettingsModalEmailSetController(
  $scope,
  $uibModalInstance,
  accountsService,
  regexService,
  modalData,
  modalConstantsService
) {
  'ngInject';

  angular.extend($scope, modalData);
  $scope.userInfo = {};
  $scope.emailSetSuccess = false;
  $scope.regexData = {};
  regexService.getEmailRegex().then(function(data) {
    if (data) {
      $scope.regexData.email = data.Regex;
    }
  });

  $scope.doesPasswordExist = modalData.doesPasswordExist;
  $scope.modalConstants = modalConstantsService;

  $scope.title = function() {
    if ($scope.emailRequired) {
      return modalConstantsService.emailSet.emailRequiredMessage;
    }

    if ($scope.emailSetSuccess) {
      return modalConstantsService.emailSet.emailSetSuccessMessage;
    }

    return $scope.changeEmail
      ? $scope.over13
        ? modalConstantsService.emailSet.changeEmailO13Label
        : modalConstantsService.emailSet.changeEmailU13Label
      : $scope.over13
      ? modalConstantsService.emailSet.addEmailO13Label
      : modalConstantsService.emailSet.addEmailU13Label;
  };

  $scope.toggleEmailRequired = function(enabled) {
    $scope.emailRequired = enabled;
  };

  $scope.submitButtonText = function() {
    return $scope.changeEmail
      ? modalConstantsService.emailSet.changeEmailLabel
      : modalConstantsService.emailSet.addEmailLabel;
  };

  $scope.emailErrorMessage = function(form) {
    if (form['userInfo.emailAddress'].$error.required) {
      return null;
    }
    if (form['userInfo.emailAddress'].$invalid) {
      return modalConstantsService.emailSet.invalidEmailAddressMessage;
    }
    if (form.$pristine && $scope.error) {
      return $scope.error;
    }
    return null;
  };

  $scope.submit = function(form) {
    form.$setPristine();
    $scope.error = '';
    if (!$scope.doesPasswordExist) {
      $scope.userInfo.password = 'placeholder';
    }

    $scope.isProcessing = true;

    accountsService
      .beginAccountAddEmailAddress($scope.userInfo)
      .then(
        function() {
          $scope.emailSetSuccess = true;
        },
        function(error) {
          $scope.error = accountsService.getEmailErrorMessageFromCode(error);
        }
      )
      .finally(function() {
        $scope.isProcessing = false;
      });
  };

  $scope.dismiss = function() {
    if ($scope.passwordSet) {
      $uibModalInstance.close(true);
    } else {
      $uibModalInstance.dismiss();
    }
  };
}

accountSettingsModule.controller(
  'accountSettingsModalEmailSetController',
  accountSettingsModalEmailSetController
);

export default accountSettingsModalEmailSetController;
